import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';
import store from '../widget/store';
import App from '../widget/App.vue';
import i18n from '../widget/i18n';
import * as Sentry from '@sentry/vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import router from '../widget/helpers/tabsRouter';
import VTooltip from 'v-tooltip';

Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(VueTelInput);
Vue.use(VTooltip);

const i18nConfig = new VueI18n({
  locale: 'en',
  messages: i18n,
});

// Event Bus
window.bus = new Vue();

Vue.config.productionTip = false;
const {
    VUE_APP_SENTRY_DSN,
    VUE_APP_ENV,
  } = process.env;

if (VUE_APP_SENTRY_DSN && VUE_APP_ENV) {
    const devEnv = 'dev';
    Sentry.init({
      Vue,
      debug: VUE_APP_ENV === devEnv ? true : false,
      dsn: VUE_APP_SENTRY_DSN,
      environment: VUE_APP_ENV === 'production' ? VUE_APP_ENV : devEnv,
      allowUrls: ["[0-9a-z]*.hiver.space/api/v1", "src/dashboard", "src/widget"],
    });
  }

window.onload = () => {
  window.WOOT_WIDGET = new Vue({
    store,
    router,
    i18n: i18nConfig,
    render: h => h(App)
  }).$mount('#app');
};
